import React from 'react';
import visualisation_svg from '../../../svg/IndividualTreatmentVisualisationStandard.svg'
import PropTypes from 'prop-types';

import IndividualTreatmentVisualisationBase from 'common/controls/IndividualTreatmentVisualisationBase'
import * as ControlConstants from 'common/controls/Magstim.Control.Constants'
import { CurrentLang } from 'common/utils/LocalisationUtils';

class IndividualTreatmentVisualisationStandard extends IndividualTreatmentVisualisationBase {

	constructor() {
		super();
		window._VisualisationStandard_setAdjustedPowerOutput = this.setAdjustedPowerOutput.bind(this);
		window._VisualisationStandard_setPowerOutput = this.setPowerOutput.bind(this);
		window._VisualisationStandard_setChargeDelay = this.setChargeDelay.bind(this);
		window._VisualisationStandard_setPulsesPerTrain = this.setPulsesPerTrain.bind(this);
		window._VisualisationStandard_setOnTime = this.setOnTime.bind(this);
		window._VisualisationStandard_setOffTime = this.setOffTime.bind(this);
		window._VisualisationStandard_setPowerChangePendingHighlight = this.setPowerChangePendingHighlight.bind(this);
	}

	onSvgLoad = (event) => {
		this.svgTreatment = event.target.contentDocument;
		this.setAdjustedPowerOutput(this.props.AdjustedPowerOutput);
		this.setPowerOutput(this.props.PowerOutput);
		this.setChargeDelay(this.props.ChargeDelay);
		this.setPulsesPerTrain(this.props.PulsesPerTrain);
		this.setOnTime(this.props.OnTime);
		this.setOffTime(this.props.OffTime);

		this.__set("labelCycleTime", CurrentLang().view_individual_treatment_burst_cycle_time);
	}

	render() {
		return (
			<object aria-label='visualisation' data={visualisation_svg} type="image/svg+xml" onLoad={this.onSvgLoad}></object>
		);
	}

	setPulsesPerTrain(value) {
		this.PulsesPerTrain = value;
		this.__set("textPulsesPerTrain", "" + Number(value).toFixed(0));
	}

	setOnTime(value) {
		// console.log(`IndividualTreatmentVisualisationStandard.setOnTime(${value})`);
		this.OnTime = value;
		this.__set("textOnTime", "" + Number(value).toFixed(1) + "s");
	}

	setOffTime(value) {
		this.OffTime = value;
		this.__set("textOffTime", "" + Number(value).toFixed(1) + "s");
	}
}

IndividualTreatmentVisualisationStandard.propTypes = {
	AdjustedPowerOutput: PropTypes.number,
	PowerOutput: PropTypes.number,
	ChargeDelay: PropTypes.number,
	PulsesPerTrain: PropTypes.number,
	OnTime: PropTypes.number,
	OffTime: PropTypes.number
};

IndividualTreatmentVisualisationStandard.defaultProps = {
	AdjustedPowerOutput: 120,
	PowerOutput: 84,
	ChargeDelay: ControlConstants.UI_STANDARD_CHARGE_DELAY.default, // 803,
	PulsesPerTrain: ControlConstants.UI_STANDARD_PULSES_PER_TRAIN.default, // 20,
	OnTime: ControlConstants.UI_STANDARD_ON_TIME.default, // 5,
	OffTime: ControlConstants.UI_STANDARD_OFF_TIME.default // 1.0
};

export default IndividualTreatmentVisualisationStandard;